import React, { useState } from 'react'
import * as moment from "moment";

const AccessorialRequest = ({ userData, addAccessorialRequest, newAccesorialRequests, clearAddedAccessorials, shipment, showOrHide, inputFieldsReadOnly, language }) => {

    const [accessoralValue, setAccessoralValue] = useState(0)
    const [accessoralID, setAccessoralID] = useState(0)
    const [readOnlyAmountAndRequest, setReadOnlyAmountAndRequest] = useState(true)

    if (shipment.settlementId) {
        return null;
    }

    // let userId = userData.id

    let checkSelectChange = (event) => {
        // console.log('checkSelectChange', event.target.value)
        if (event && (event.target.value !== "")) {
            setReadOnlyAmountAndRequest(false)
            setAccessoralID(event.target.value)
        }
    }

    let changeaccessoralValue = (event) => {
        if (event && (event.target.value !== "")) {
            setAccessoralValue(event.target.value)
        }
    }

    let submitNewAccessoralReqeustToArray = () => {
        let accessorialFormDisplay = userData.clientAccessorials.filter((accesorial) => {
            if (parseInt(accesorial.accessorialID) === parseInt(accessoralID)) {
                return accesorial.accessorialFormDisplay
            } else {
                console.warn("AccessorialRequest, submitNewAccessoralReqeustToArray could not identify the accessorial selected to pick a name.")
                return null
            }
        })
        addAccessorialRequest({
            accessorialId: accessoralID,
            amount: accessoralValue,
            carrier_userId: localStorage.getItem("id"),
            formDisplayName: accessorialFormDisplay[0].accessorialFormDisplay,
            webquotecontrol: shipment.id

        })
    }



    if (userData.clientAccessorials && (showOrHide === "show" || showOrHide === "hilight")) {

        return (
            <fieldset id="accesorialRequests" className="border p-2 w-100">
                <legend className="w-auto">
                    {language && language.code === "es" ? "Solicitudes de Accesorios:" : "Accessorial Requests:"}
                </legend>
                <div className="mt-2 mb-2 d-flex flex-column flex-md-row">
                    {/* Request */}
                    <div className="">
                        {!moment().diff(moment(shipment.dates.pickupDate), 'days') <= 7 ? (<><div>
                            <label>Request Additional Accessorial Charge(s):</label>
                        </div>
                            <div className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center">
                                <select className="form-control form-control-sm mb-1 mb-md-0 mr-md-2" id="accessorialCharge" onChange={(event) => checkSelectChange(event)} disabled={inputFieldsReadOnly}>
                                    <option value="">Choose...</option>

                                    {userData.clientAccessorials.map((accesorial, index) => {
                                        return (<option key={index} value={accesorial.accessorialID}>{accesorial.accessorialFormDisplay}</option>)
                                    })}
                                </select>
                                <input type="number" className="form-control form-control-sm mb-1 mb-md-0 mr-md-2" placeholder="Accessorial Price" readOnly={readOnlyAmountAndRequest || inputFieldsReadOnly} onChange={(event) => changeaccessoralValue(event)}></input>
                                <button className="btn btn-outline-secondary btn-sm" type="button" id="accessorialChargeAdd" disabled={readOnlyAmountAndRequest || inputFieldsReadOnly} onClick={() => submitNewAccessoralReqeustToArray()}>Add Request</button>

                            </div></>) : null}

                        {shipment.accessorialRequests && shipment.accessorialRequests.length ?
                            (

                                <React.Fragment>
                                    <div className=" mt-3 card">
                                        <div className="card-body">
                                            <label>Past Accessorial Requests:</label>
                                            <table class="table table-sm">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Name</th>
                                                        <th scope="col">Amount</th>
                                                        <th scope="col">Status</th>
                                                        <th scope="col">Reason</th>
                                                    </tr>
                                                </thead>
                                                <tbody>



                                                    {shipment.accessorialRequests.map((request, index) => {
                                                        return (
                                                            <tr>
                                                                <td>{request.accessorialFormDisplay}</td>
                                                                <td>${request.amount}</td>
                                                                <td>
                                                                    {request.accepted === 1 ? "Accepted" : null}
                                                                    {request.declined === 1 ? "Declined" : null}
                                                                    {request.declined === 0 && request.accepted === 0 ? "Pending" : null}
                                                                </td>
                                                                <td>{request.declineReason}</td>
                                                            </tr>)
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )
                            : null
                        }
                    </div>
                    {/* Selected Accessorial Requests  */}
                    {newAccesorialRequests.length ?
                        (
                            <div className="mt-3 ml-md-4">

                                <label>Selected Accessorial Requests:</label>
                                <div className="card">

                                    <div className="card-body">
                                        <ul>
                                            {newAccesorialRequests.map((request, index) => {
                                                return (
                                                    <React.Fragment key={index}><li>{request.formDisplayName}, ${request.amount}</li></React.Fragment>
                                                )
                                            })}
                                        </ul>

                                    </div>
                                    <div className="card-footer bg-transparent">
                                        <button className="btn btn-outline-secondary btn-sm" onClick={() => clearAddedAccessorials()}>Reset</button>
                                    </div>
                                </div>

                                <div className="alert alert-warning d-inline-block mt-2">Click "Update Shipment" to send request(s).</div>
                            </div>
                        )
                        : null}

                </div >
            </fieldset>
        )
    } else {
        return null
    }
}

export default AccessorialRequest
